import { createIcon } from '@chakra-ui/react'

export const FoxIcon = createIcon({
  displayName: 'FoxIcon',
  path: (
    <g fill='currentColor'>
      <path
        fill='currentColor'
        d='M19.636.994a.657.657 0 0 0-.658-.66c-.366 0-.147 0-.22.036h-.036l-5.668 2.387H6.655L.915.37C.84.37.767.333.657.333A.657.657 0 0 0 0 .994v.074c0 .036 1.316 8.078 1.316 8.078l-1.28 4.37v.22c0 .256.147.477.33.587l4.168 2.13c1.682 1.028 2.377 2.203 3.657 3.708l1.097 1.249v.073c.183.11.329.184.512.184a.589.589 0 0 0 .475-.22l1.097-1.286c1.28-1.505 1.975-2.68 3.657-3.708l4.168-2.13c.22-.11.33-.33.33-.588v-.183l-1.28-4.37 1.316-8.078v-.073l.073-.037Zm-1.938 1.653-.732 4.516-2.413-3.158 3.181-1.322-.036-.036ZM6.838 4.446h5.923l2.962 3.892H3.876l2.962-3.892Zm2.998 10.318-5.521-4.737h11.043l-5.522 4.737ZM5.12 3.968 2.706 7.126 1.975 2.61l3.18 1.322-.036.036Zm-3.181 9.107.695-2.093 4.717 4.222-5.412-2.13Zm7.898 5.948-2.084-2.497 2.084.294 2.085-.294-2.085 2.497Zm2.45-3.819 4.717-4.222.695 2.093-5.412 2.13Z'
      />
    </g>
  ),
  viewBox: '0 0 20 22',
})
